export default __webpack_public_path__ + "static/media/survei_kepuasan.60321199.png";